import baseService from "../services/index";

/**
 * There is pre-requisite to use this mixin
 * This mixin used on XbaseHeader and MicroAppsContainer
 * @computed accessToken data stored in auth vuex
 */
export default {
  watch: {
    accessToken(val) {
      if (val && this.$store.state.auth.signedIn) {
        if (this.fetchIsRegisteredStatus && !this.additionalProfileInfo) {
          this.fetchIsRegisteredStatus();
        } else {
          this.fetchPermission();
        }
      }
    }
  },
  mounted() {
    if (process.env.NODE_ENV === "development") {
      this.$store.commit("rules/setRules", [
        {
          subject: "all",
          action: ["READ", "UPDATE", "DELETE", "CREATE"]
        }
      ]);
      this.constructServiceMenu();
    } else if (
      this.$route.path.includes("public-register") ||
      this.$route.path.includes(
        "suspended-or-revoked-salespersons-&-estate-agents"
      ) ||
      (this.$route.path.includes("feedback-management") &&
        !this.$store.state.auth.signedIn)
    ) {
      if (this.loadMicroAppAfterFetch) this.loadMicroAppAfterFetch();
    } else if (
      this.$route.name !== "Login" &&
      this.$route.name !== "OidcCallback" &&
      this.accessToken
    ) {
      if (!this.fetchIsRegisteredStatus) {
        this.fetchPermission();
      }
    }
  },
  methods: {
    fetchPermission() {
      const permissionEndpoint = this.$store.state.config.configurationData
        .common_module.permissions.getPermissionEndpoint;
      const accessToken = this.$store.state.auth.accessToken;
      baseService(
        permissionEndpoint,
        { entityUri: "/*" },
        this.handleFetchPermission,
        e => {
          return e.message;
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
    },
    handleFetchPermission(response) {
      const data = response.data.data;

      const privileges = ["READ", "UPDATE", "DELETE", "CREATE"];
      let permissions = [];
      for (const key in data) {
        let actions = [];
        privileges.forEach(privilege => {
          if (data[key][privilege]) {
            actions.push(privilege);
          }
        });

        permissions.push({
          action: actions,
          subject: key
        });
      }

      this.$store.commit("rules/setRules", permissions);
      this.constructServiceMenu();
      if (this.loadMicroAppAfterFetch) this.loadMicroAppAfterFetch();
    },
    constructServiceMenu() {
      const _this = this;
      const newData = this.$store.getters["menus/headersRawMenu"];
      const updatedData = [];
      newData.forEach(element => {
        let isEveryChildHasPermission =
          element.childs && element.childs.length > 0
            ? element.childs.some(child =>
                _this.$can("READ", child.meta.entity)
              )
            : _this.$can("READ", element.meta.entity);

        if (
          !element.meta.envExclusion ||
          (element.meta.envExclusion &&
            !element.meta.envExclusion.includes(
              this.$store.state.config.configurationData.environment
            ))
        ) {
          if (isEveryChildHasPermission) {
            if (element.childs) {
              const childPathObj = element.childs.filter(item => {
                if (item.meta.entity && Array.isArray(item.meta.entity)) {
                  return (
                    item.meta.entity.some(entityUri =>
                      _this.$can("READ", entityUri)
                    ) &&
                    (item.meta.envExclusion
                      ? !item.meta.envExclusion.includes(
                          this.$store.state.config.configurationData.environment
                        )
                      : true)
                  );
                } else {
                  const isCustomPermissionPassed = item.meta.customPermission;
                  if (item.meta.entity) {
                    if (isCustomPermissionPassed) {
                      return (
                        _this.$can("READ", item.meta.entity) &&
                        item.meta.customPermission()
                      );
                    }

                    return (
                      _this.$can("READ", item.meta.entity) &&
                      (item.meta.envExclusion
                        ? !item.meta.envExclusion.includes(
                            this.$store.state.config.configurationData
                              .environment
                          )
                        : true)
                    );
                  } else {
                    return item.meta.envExclusion
                      ? !item.meta.envExclusion.includes(
                          this.$store.state.config.configurationData.environment
                        )
                      : true;
                  }
                }
              });

              updatedData.push({
                ...element,
                childs: childPathObj.length > 1 ? childPathObj : []
              });
            } else {
              updatedData.push({
                ...element
              });
            }
          }
        }
      });

      this.$store.commit("menus/setServiceMenu", updatedData);
      this.$store.commit("setApplicationLoadingToFalse");
    }
  }
};
